interface Props {
  readonly condition: boolean;
  readonly children: React.ReactNode;
}

const VisibleIf: React.FC<Props> = ({ condition, children }) => {
  return <div style={{ visibility: condition ? 'visible' : 'hidden' }}>{children}</div>;
};

export default VisibleIf;
